module.exports = __webpack_public_path__ + "static/media/imgCard03.b7f288a5.png";